/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Vimeo_LabelInputs */



/**
* | output |
* | --- |
* | "Vimeo Page URL" |
*
* @param {Media_Import_Vimeo_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_vimeo_label = /** @type {((inputs?: Media_Import_Vimeo_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Vimeo_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL de la page Vimeo")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vimeo-Seiten-URL")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL della pagina Vimeo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL страницы Vimeo")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL de la página de Vimeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Vimeo 页面网址")
	if (locale === "ja") return /** @type {LocalizedString} */ ("VimeoページのURL")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Vimeo पेज URL")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL da página do Vimeo")
	return /** @type {LocalizedString} */ ("Vimeo Page URL")
});